module.exports = __webpack_public_path__ + "static/media/4.429849d3.jpg";